import MuiCheckbox, { CheckboxProps as MuiCheckboxProps } from "@mui/material/Checkbox";

export type CheckboxProps = MuiCheckboxProps & {
  dataDogIdentifier: string;
};

const Checkbox: React.FC<CheckboxProps> = ({ dataDogIdentifier, ...props }) => {
  return <MuiCheckbox {...props} data-action-name={`${dataDogIdentifier} checkbox`} />;
};

Checkbox.displayName = "Checkbox";

export default Checkbox;
